<style lang="scss" scoped>
.el-dropdown {
  width: 250px;
  position: absolute;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  border: 1px solid #eeeff6;
  background-color: #ffffff;
  z-index: 1005;
  top: 45px;
  left: 25px;
  &.right {
    left: -50%;
    right: auto;
    @media only screen and (min-width: 786px) {
      left: auto;
      right: 0;
    }
  }
  .divider {
    border-color: #eeeff6 !important;
  }
  .items {
    padding: 0px 0;
    ::v-deep .item {
      transition: 0.3s background;
      cursor: pointer;
      user-select: none;
      padding: 15px 20px;
      &:first-child {
        border-radius: 4px 4px 0 0;
      }
      &:last-child {
        border-radius: 0 0 4px 4px;
      }
      &.disabled {
        color: #b2b2b2 !important;
        cursor: not-allowed;
      }
      &:not(.router-link-active):not(.disabled):hover {
        background: #f8fafb;
      }
      &.router-link-active {
        color: var(--primary) !important;
      }
    }
  }
}
</style>

<template>
  <div :class="{ open: open }" @click="handleOpen" v-click-outside="handleClose">
    <slot name="handle"></slot>

    <slide-y-up-transition>
      <div v-if="open" @click.stop class="el-dropdown" :class="direction" :style="{ width: width }">
        <div class="items">
          <slot name="items"></slot>
        </div>
      </div>
    </slide-y-up-transition>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import { SlideYUpTransition } from 'vue2-transitions';

export default {
  directives: {
    ClickOutside,
  },

  components: { SlideYUpTransition },

  props: {
    width: {
      required: false,
      default: '250px',
    },
    direction: {
      default: 'right',
    },
    openable: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      open: false,
    };
  },

  methods: {
    handleOpen() {
      if (this.openable) {
        this.open = !this.open;
        if (this.open) this.$emit('open');
      } else {
        this.open = false;
      }
    },
    handleClose() {
      this.$emit('close');
      this.open = false;
    },
  },
};
</script>
